import React from "react";
import Select, { components } from "react-select";

function createSelectStyles(size) {
  const minHeight = size === "lg" ? "56px" : "2.813rem";

  return {
    control: (base, state) => ({
      ...base,
      minHeight,
      height: size === "lg" ? "56px" : undefined,
      borderRadius: "0.5rem",
      borderColor: state.isFocused ? "#c6272a" : "#e6e6e6",
      boxShadow: "none",
      backgroundColor: size === "lg" ? "var(--neutral-50, #f8fafc)" : "#fff",
      "&:hover": {
        borderColor: state.isFocused ? "#c6272a" : "#d1d5db",
      },
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 0.75rem",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#a5a5a5",
      fontSize: "13px",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "13px",
    }),
    input: (base) => ({
      ...base,
      fontSize: "13px",
      margin: 0,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "100%",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 30,
      overflow: "hidden",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 2400,
    }),
    groupHeading: (base) => ({
      ...base,
      fontSize: "12px",
      fontWeight: 700,
      color: "#6b7280",
      textTransform: "none",
      letterSpacing: 0,
      padding: "8px 12px 6px",
      marginBottom: 0,
      borderBottom: "1px solid #eef0f3",
    }),
    option: (base, state) => ({
      ...base,
      fontSize: "13px",
      backgroundColor: state.isSelected
        ? "#c6272a"
        : state.isFocused
          ? "rgba(198, 39, 42, 0.08)"
          : "transparent",
      color: state.isSelected ? "#fff" : "inherit",
    }),
    noOptionsMessage: (base) => ({
      ...base,
      fontSize: "13px",
      color: "#6b7280",
      padding: "12px",
    }),
  };
}

function MenuWithAction(props) {
  const action = props.selectProps.menuAction;
  return (
    <components.Menu {...props}>
      {props.children}
      {action ? (
        <div className="agent-select-menu-footer">
          <button
            type="button"
            className="agent-select-menu-action"
            onMouseDown={(event) => {
              event.preventDefault();
              event.stopPropagation();
              if (typeof action.onClick === "function") action.onClick();
            }}
          >
            {action.icon || null}
            <span>{action.label}</span>
          </button>
        </div>
      ) : null}
    </components.Menu>
  );
}

export const agentSelectStyles = createSelectStyles();

export function toSelectOption(options, value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const target = String(value);
  for (const option of options) {
    if (option && Array.isArray(option.options)) {
      const nested = option.options.find((item) => String(item?.value) === target);
      if (nested) return nested;
      continue;
    }
    if (option && String(option.value) === target) {
      return option;
    }
  }
  return null;
}

export default function AgentSelect({
  value,
  options = [],
  onChange,
  name,
  placeholder = "Select...",
  isDisabled = false,
  isClearable = false,
  isLoading = false,
  isSearchable = true,
  className = "",
  inputId,
  size,
  menuAction,
  noOptionsMessage,
  components: componentsOverride,
  ...rest
}) {
  return (
    <Select
      inputId={inputId}
      name={name}
      className={`agent-select ${size === "lg" ? "agent-select--lg" : ""} ${className}`.trim()}
      classNamePrefix="agent-select"
      styles={createSelectStyles(size)}
      options={options}
      value={toSelectOption(options, value)}
      onChange={(option) => {
        if (onChange) {
          onChange(option ? option.value : "", option);
        }
      }}
      {...rest}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isClearable={isClearable}
      isLoading={isLoading}
      isSearchable={isSearchable}
      noOptionsMessage={noOptionsMessage}
      menuAction={menuAction}
      components={{
        ...(menuAction ? { Menu: MenuWithAction } : {}),
        ...componentsOverride,
      }}
      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
      menuPosition="fixed"
    />
  );
}
